import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'

Vue.use(Vuex)

const initialState = {
  credentials: {},
  user: {},
  status: false,
  api,
  smartthon: {
    isCover: false
  },
  env: process.env,
  avatar: '',
  notification: [],
  moving: false,
  version: {
    now: '',
    isReload: false
  }
}

export default new Vuex.Store({
  state: initialState,
  mutations: {
    onAuthStateChanged (state, credentials) {
      state.credentials = credentials
    },
    onUserStateChanged (state, user) {
      state.user = user
    },
    onLoginStatusChanged (state, status) {
      state.status = status
    },
    onSmartthonStateChanged (state, data) {
      state.smartthon = data
    },
    onAvatarStateChanged (state, avatarId) {
      state.avatar = `${state.env.S3}/enterprise/avatar/${avatarId}.png`
    },
    onNotificationStateChanged (state, data) {
      state.notification = data
    },
    onMovingChanged (state, data) {
      state.moving = data
    },
    onVersionChanged (state, data) {
      if (state.version.now && state.version.now !== data) state.version.isReload = true
      else state.version.now = data
    }
  },
  getters: {
    credentials (state) {
      return state.credentials
    },
    user (state) {
      return state.user
    },
    isSignedIn (state) {
      return state.status
    },
    api (state) {
      return state.api
    },
    smartthon (state) {
      return state.smartthon
    },
    env (state) {
      return state.env
    },
    avatar (state) {
      return state.avatar
    },
    notification (state) {
      return state.notification
    },
    moving (state) {
      return state.moving
    },
    version (state) {
      return state.version
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js